import { FaSearch, FaTimes } from 'react-icons/fa';

const autocompleteInput = (props) => {
  const { cancelAction, inModal, placeholder, ...otherProps } = props;
  let classes =
    'pl-10 text-sm font-light flex-grow py-2.5 focus:outline-none focus:text-gray-900';
  if (inModal) {
    classes += ' border-b';
  } else {
    classes += ' rounded-xl border border-gray-300 ';
  }
  return (
    <>
      <div
        className="flex w-full
      "
      >
        <input
          type="search"
          className={classes}
          placeholder={placeholder}
          autoComplete="off"
          {...otherProps}
        />
      </div>
      <span className="absolute inset-y-0 left-4 flex items-center cursor-pointer">
        <FaSearch className="text-gray-600" />
      </span>
      {!!props.value?.length && (
        <span className="absolute inset-y-0 right-5 flex items-center cursor-pointer">
          <a onClick={() => cancelAction()}>
            <FaTimes className="text-gray-600" />
          </a>
        </span>
      )}
    </>
  );
};

export default autocompleteInput;
